var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChevronDownIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.59204 6.95001L11.3004 2.23334C11.3785 2.15587 11.4405 2.0637 11.4828 1.96215C11.5251 1.8606 11.5469 1.75168 11.5469 1.64167C11.5469 1.53166 11.5251 1.42274 11.4828 1.32119C11.4405 1.21964 11.3785 1.12747 11.3004 1.05001C11.1442 0.894796 10.933 0.807678 10.7129 0.807678C10.4927 0.807678 10.2815 0.894796 10.1254 1.05001L5.95871 5.17501L1.83371 1.05C1.67757 0.894796 1.46636 0.807678 1.24621 0.807678C1.02605 0.807678 0.814845 0.894796 0.65871 1.05C0.579969 1.12718 0.517327 1.21922 0.474414 1.32078C0.431499 1.42235 0.409168 1.53142 0.40871 1.64167C0.409168 1.75193 0.431499 1.861 0.474414 1.96256C0.517327 2.06412 0.579969 2.15616 0.658709 2.23334L5.36704 6.95001C5.44508 7.03459 5.53979 7.1021 5.6452 7.14827C5.75062 7.19445 5.86446 7.21828 5.97954 7.21828C6.09463 7.21828 6.20846 7.19445 6.31388 7.14827C6.4193 7.1021 6.51401 7.03459 6.59204 6.95001Z",
    fill: "#002145",
    fillOpacity: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDownIcon);
export default __webpack_public_path__ + "static/media/chevron_down_icon.f77c88a7b0c89479afcdfb4884e3b066.svg";
export { ForwardRef as ReactComponent };